module.exports = __webpack_public_path__ + "img/content1.bd12626a.png";